import React, { useState, useCallback } from "react";
import { Button, Form, Input, Loader } from "semantic-ui-react";
import { Container, Title } from "./styles";

import { Link } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 } from "../../../../../services/apis";
import swal from "sweetalert";

const GerarCertificado = () => {
  const [userId, setUserId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (e) => {
      if (!userId || !courseId) {
        swal("Ops !", "Usuário ou curso em branco", "error");
        return;
      }

      setLoading(true);

      try {
        e.preventDefault();

        await producaov2.post("/admin/certificate",
          {
            userId: userId,
            courseId: courseId,
            needRegenerate: true
          }
        )
        .then((res) => {
          if (res.data.url) {
            window.open(res.data.url, "_blank");
          }
          setLoading(false);
        });
      } catch (err) {
        swal("Ops !", err, "error");
        setLoading(false);
      }
    },
    [userId, courseId]
  );

  return (
    <>
      <AdminMenu />
      <Container>
        <Title>Gerar certificado</Title>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Id pessoa</label>
              <Input
                placeholder="Id pessoa"
                name="pessoa"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Id curso</label>
              <Input
                placeholder="Id curso"
                name="curso"
                value={courseId}
                onChange={(e) => setCourseId(e.target.value)}
              />
            </Form.Field>
          </Form.Group>
          {loading ? (
            <Loader active inline="centered" size="massive" />
          ) : (
            <Form.Group>
              <Form.Field>
                <Button onClick={handleSubmit}>Gerar</Button>
              </Form.Field>
              <Link to="/admin/ead/certificados">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          )}
        </Form>
      </Container>
    </>
  );
};

export default GerarCertificado;
